import ScrollingMenu from "./ScrollingMenu";
import MenuList from "./MenuList";
import LimitedTimeOfferCard from "./LimitedTimeOfferCard";
import MenuCarouselCard from "./MenuCarouselCard";
import FavoritemMenuCard from "./FavoritemMenuCard";
import RecentOrderMenuCard from "./RecentOrderMenuCard";
import NoFavoritesDiplayBoard from "./NoFavoritesDiplayBoard";
import NoRecentOrderDisplayBoard from "./NoRecentOrderDisplayBoard";
import MenuItemCard from "./MenuItemCard";
import ComboPage from "./ComboPage";
import ComboFavoritesAndRecentOrdersModal from "./ComboFavoritesAndRecentOrdersModal";

export default class MenuLandingPage extends React.Component {
    constructor(props) {
        super(props);
        this.menuListData = this.props.categoriesAndProductData;
        this.showCarousel = this.props.recentOrdersData != null && this.props.recentOrdersData.Orders != null && this.props.recentOrdersData.Orders.length > 1;
        this.showMenuCarousel = this.props.menuCarouselData != null && this.props.menuCarouselData.Cards != null && this.props.menuCarouselData.Cards.length > 0;
        this.menuCarouselData = this.props.menuCarouselData;
        this.getComboPage = this.getComboPage.bind(this);
        this.getUrlData = this.getUrlData.bind(this);
        this.pushItemDetailsToGA = this.pushItemDetailsToGA.bind(this);
        this.pushViewItemListToGA = this.pushViewItemListToGA.bind(this);
        this.pushSelectItemToGA = this.pushSelectItemToGA.bind(this);
        this.resetMenuCatPage = this.resetMenuCatPage.bind(this);
        this.getNotificationForFavecardUpdate = this.getNotificationForFavecardUpdate.bind(this)
        this.recentOrders = this.props.recentOrdersData;
        this.returnFaveMenuCards = this.returnFaveMenuCards.bind(this)
        this.state = {
            menuItemCurrentData: [],
            isCategoryPage: true,
            autoLinkData: null,
            isMenuItemPage: false,
            favMenuCardSets: [],
            isComboPage: false
        };
        this.comboPageData = this.props.productDetailData;
        this.state.isComboPage = this.comboPageData != null;
        this.restaurantId = null;
    }
    pushItemDetailsToGA() {
        try {

            if (this.state.isCategoryPage && this.state.menuItemCurrentData.length == 0 && this.menuListData && this.menuListData.Categories) {

                this.pushViewItemListToGA();
            }

            if (this.state.isCategoryPage && this.state.menuItemCurrentData.length > 0 && this.state.menuItemCurrentData[0].MenuItems != null) {

                this.pushSelectItemToGA();
            }
        }
        catch (ex) {
            console.log(ex)
        }
    }

    pushViewItemListToGA() {
        try {
            var menuItems = [];
            const batchSize = 200;
            for (var index = 0; index < this.menuListData.Categories.length; index++) {
                var menuItem = {
                    'item_id': this.menuListData.Categories[index].CategoryId,
                    'item_name': this.menuListData.Categories[index].Name,
                    'item_brand': 'ihop'
                };
                menuItems.push(menuItem);
                if (menuItems.length === batchSize || index == (this.menuListData.Categories.length - 1)) {
                    //window.dataLayer = window.dataLayer || [];
                    //window.dataLayer.push({ 'ecommerce': null });
                    //window.dataLayer.push({
                    //    'event': 'view_item_list',
                    //    'ecommerce': {
                    //        'item_list_name': 'undefined',
                    //        'item_list_id': 'undefined',
                    //        'currency': 'USD',
                    //        'items': menuItems
                    //    }
                    //});
                    menuItems = [];
                }
            }
        }
        catch (ex) {
            console.log(ex)
        }
    };

    pushSelectItemToGA() {
        try {
            var menuItems = [];
            for (var index = 0; index < this.state.menuItemCurrentData[0].MenuItems.length; index++) {
                var menuItem = {
                    'item_id': this.state.menuItemCurrentData[0].MenuItems[index].MenuItemId,
                    'item_name': this.state.menuItemCurrentData[0].MenuItems[index].Name,
                    'item_brand': 'ihop',
                    'item_category': this.state.menuItemCurrentData[0].Name,
                    'item_category2': 'undefined',
                    'item_category3': 'undefined',
                    'item_category4': 'undefined',
                    'item_variant': this.state.menuItemCurrentData[0].MenuItems[index].VariationName,
                    'affiliation': 'undefined',
                    'price': this.state.menuItemCurrentData[0].MenuItems[index].Price,
                    'discount': 'undefined',
                    'quantity': '1',
                    'index': index + 1
                };
                menuItems.push(menuItem);
                if ((index + 1) % 20 == 0 || index == (this.state.menuItemCurrentData[0].MenuItems.length - 1)) {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({ 'ecommerce': null });
                    window.dataLayer.push({
                        'event': 'select_item',
                        'ecommerce': {
                            'item_list_name': this.state.menuItemCurrentData[0].Name,
                            'item_list_id': this.state.menuItemCurrentData[0].CategoryId,
                            'currency': 'USD',
                            'items': menuItems
                        }
                    });
                    menuItems = [];
                }
            }
        }
        catch (ex) {
            console.log(ex)
        }
    };
    /*
    scrollFavItemsCardsToTheLeft(e) {
        e.preventDefault();
        document.getElementById('fav-item-scroll-control').scrollLeft += 320;

    }
    scrollFavItemsCardsToTheRight(e) {
        e.preventDefault();
        document.getElementById('fav-item-scroll-control').scrollLeft -= 320;

    }
    handleFavEnterKeyPress() {
        if (event.keyCode == 13) {
            $("#recordnone .nav-pills .recent_pill").click();
            $("#recordnone").modal('show');
        }
    }
    loadFavRecentOrderModal() {
        $("#recordnone .nav-pills .recent_pill").click();
        $("#recordnone").modal('show');
    }
    openFavModal(e) {
        e.preventDefault();
        $("#recordnone .nav-pills .fav_pill").trigger('click');
        $('#recordnone').modal('show');
    }
    */
    getComboPage() {
        this.setState({
            isMenuItemPage: false, isCategoryPage: false, isComboPage: true
        });
    }

    returnFaveMenuCards(allFaveCardsData) {
        let favMenuCardSets = [];
        let topFive = []
        if (allFaveCardsData) {
            topFive = this.returnFirstFive(allFaveCardsData, 5);
            topFive.map(favData => {

                favMenuCardSets.push(
                    <div className="fav-orders-container col">
                        <FavoritemMenuCard favTitle={favData.name}
                            favProducts={favData.products}
                            buttonText={this.props.favoritesData.ReorderButtonText}
                            favId={favData.id} />
                    </div>
                )
            });
        }

        return favMenuCardSets

    }

    returnRecentOrderMenuCards(allRecentOrderCardsData) {
        let recentOrderMenuCardSets = [];
        let topFive = []
        if (allRecentOrderCardsData) {
            topFive = this.returnFirstFiveRecent(allRecentOrderCardsData, 5);
            topFive.map(recentData => {

                recentOrderMenuCardSets.push(
                    <div className="fav-orders-container col">
                        <RecentOrderMenuCard Title={recentData.orderName}
                            recentProducts={recentData.basket.products}
                            basketId={recentData.basket.id}
                            buttonText={this.props.favoritesData.ReorderButtonText} />
                    </div>
                )
            });
        }

        return recentOrderMenuCardSets

    }

    getNotificationForFavecardUpdate() {
        var reactRefThis = this;
        $.ajax({
            method: "GET",
            url: "/api/sitecore/Menu2/UserFavorites",
        }).done(function (response) {
            var newCardSets = reactRefThis.returnFaveMenuCards(response.data)
            var finalRender = <div className="d-flex">{newCardSets}</div>
           
            const favCardcontainer = document.getElementById('fav-cards-container');
            const root = ReactDOM.createRoot(favCardcontainer);

            setTimeout(() => {
                root.render(finalRender);
            }, 500);

            /*
            setTimeout(() => {
                ReactDOM.render(finalRender,
                    document.getElementById('fav-cards-container'));
            }, 500);
             */
        }).fail(function () {
            if (DE.ProgressIndicator) {
                DE.ProgressIndicator.hideIndicator();
            }
            if (DE.AlertMessageBar) {
                try {
                    var alert = {
                        AlertMessage: {},
                        RelatedItems: []
                    }
                    alert.AlertMessage.Message = "An unexpected error occurred";
                    alert.AlertMessage.Type = 3;
                    DE.AlertMessageBar.handleAlert(alert);
                } catch (e) {
                    console.log('unable to render fave card details.')
                }
            }
        });


    }

    componentDidMount() {
        if (location) {
            let currentPath = location.pathname;
            this.setState({
                autoLinkData: currentPath
            });

            if (currentPath.includes("en/menu/")) {
                this.getUrlData(currentPath);
                // else redirect to 404 page
            }
        }
        //Grab restaurant ID drom data-values attribute

        var restauantIdDomData = $('span.location-header-link');

        MenuLandingPage.restaurantId = restauantIdDomData[0].dataset.value;
        this.pushItemDetailsToGA();

        document.querySelectorAll('.ihop-listing-menucards-subcategory-section').forEach(elem => {
            elem.parentNode.closest('.ihop-listing-menucards-subcategory').setAttribute('id', elem.getAttribute('data-subcategory'))
        });
        $('.categories-menu-page .sub-navigation-primary-container .scrolltab .scrolling-menu-item-list').eq(0).addClass('active-first');
       
        // Add event listener for pageshow to remove loader  
        window.addEventListener('pageshow', (event) => {
            if (event.persisted) {
                console.log('pageshow event fired - remove loader');
                /*if (DE.ProgressIndicator) {
                    DE.ProgressIndicator.hideIndicator();
                }*/
                var spinner = $('.c-progress__spinner-container');
                if (spinner.length > 0) {
                    if (!$(spinner).hasClass('hidden')) {
                        $(spinner).addClass('hidden');
                    }
                }
            }
        }); 
    }
    resetMenuCatPage(allMenuData) {
        $(".menu-lists-item-title-container").css({ "margin-top": "30px", "margin-left": "14px" });
        this.setState({
            isMenuItemPage: false, isCategoryPage: true
        });
    }
    getUrlData(UrlData) {
        // if it is combo page, route to Combo Component
        $(".menu-lists-item-title-container").css({ "margin-top": "-19px", "margin-left": "15px" });
        this.setState({
            isMenuItemPage: true, isCategoryPage: false
        });
        if (!this.state.isComboPage) {

            this.state.menuItemCurrentData = this.menuListData.Categories.filter((menuItemData) => {

                return (UrlData === menuItemData.PageUrl)

            });
            if (this.state.menuItemCurrentData.length == 0) {
                history.pushState({}, "Menu", "/en/menu");
            }
        }
    }
    returnFirstFive(favecardObjList, topFive) {
        if (topFive > favecardObjList.length) {
            return favecardObjList;
        }
        return favecardObjList
            .slice()
            .sort((a, b) => {
                return b.id - a.id
            })
            .slice(0, topFive);

    }
    returnFirstFiveRecent(recentcardObjList, topFive) {
        if (topFive > recentcardObjList.length) {
            return recentcardObjList;
        }
        return recentcardObjList
            .slice(0, topFive);

    }
    render() {
        return (
            <div className="categories-menu-page">
                {(!this.state.isComboPage) &&
                    <div className="">
                        <ScrollingMenu
                            categories={this.menuListData.Categories}
                            sendUrlCategoryData={this.getUrlData}
                            resetMenuCatPage={this.resetMenuCatPage}
                            autoLinkData={this.state.autoLinkData}
                            isSignedIn={this.props.isUserSignedIn}
                            allText={this.props.menuItems.AllMenuItem}
                            favoriteText={this.props.menuItems.FavoritesMenuItem}
                            recentOrderText={this.props.menuItems.RecentOrderMenuItem}
                            deliveryFeeStandard={this.props.deliveryFeeStandard}
                        
                        />
                    </div>
                }
                <div className="menu-main-layout">
                    <div className="">
                        <div className="main-menus-container">
                            <div className="main-menus-topsection container">
                                <div className="row topmenurow">
                                    {/*{this.props.menuLandingPage && */}
                                    {/*    <p className="menu-text"><strong>{this.props.deliveryFeeStandard} </strong></p>}*/}
                                    {this.showMenuCarousel &&
                                        <div className="lto usernotsignedin menucarouselstyle">
                                            <div className="home-promotions-carousel">
                                                <div className="home-promotion-section">
                                                    <div className="current-promotions-carousel">
                                                        <div className="menu-owl-carousel owl-carousel">
                                                            {this.menuCarouselData.Cards.map(card => {
                                                                return (
                                                                    <MenuCarouselCard CardItem={card} />
                                                                );
                                                            })}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    {(this.LimitedTimeData) &&
                                        <div className={!this.props.isUserSignedIn ? "col-sm-6 lto" : "col-sm-12 col-md-6 lto-signedin"}>
                                            <LimitedTimeOfferCard productName={this.LimitedTimeData.ProductName}
                                                imageUrl={this.LimitedTimeData.ImageUrl}
                                                cardTitle={this.LimitedTimeData.Title}
                                                pageUrl={this.LimitedTimeData.PageUrl} />
                                        </div>
                                    }
                                </div>
                            </div>

                            {!this.state.isComboPage &&
                                <div className="ihop-listing-menucards">
                                    <div className="container">
                                        <div className="row" data-cat={this.state.isMenuItemPage}>
                                            <div className="col-12">
                                                <div className="section-header full-menu">
                                                    {this.state.isCategoryPage ? <h1 className="js-category h2"></h1> : <h1 className="js-category h1">{this.state.menuItemCurrentData[0].Name}</h1>}
                                                    {!this.state.isCategoryPage ? <div className="divider"></div> : ""}
                                                    {this.state.isCategoryPage ? <h2 className="js-category h2"></h2> : <h2 className="js-category h2 category-menu-desc">{this.state.menuItemCurrentData[0].Description}</h2>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {this.state.isCategoryPage && this.props.menuTitle &&                                 
                                <div className="centered-menu-title"><h1>{this.props.menuTitle}</h1></div>            
                            }
                            <div className="ihop-listing-menu">
                                {/*display Menu List Items*/}
                                <div className="ihop-listing-menucards full-menus-container menu-cards-section">
                                    <div className="container">
                                        <div className="row align-items-center equal-cols">
                                            {!this.state.isComboPage && this.state.isCategoryPage &&
                                                this.menuListData.Categories.map(menuData => {
                                                    return (
                                                        //<div className='ihop-listing-menucards-subcategory' id={menuData.Name.replace(/[\s&\(),‘N+']/g, "-")} data-subcategory={menuData.Name.replace(/[\s&\(),‘N+']/g, "-")}>
                                                        
                                                        <div className='ihop-listing-menucards-subcategory'>
                                                            <div className="ihop-listing-menucards">
                                                                <div className="container">
                                                                    <div className="row">
                                                                        <div className="col-12">
                                                                            <div className="section-header full-menu" >
                                                                                <div className="js-category h1">{menuData.Name}</div>
                                                                                <div className="divider"></div>
                                                                                {menuData.Description ? <div className="js-category h2 category-menu-desc">{menuData.Description}</div> : <div className="js-category h2"></div>}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>


                                                            <section className="sub-category">
                                                                <div className="container">
                                                                    <div className="row">
                                                                        {menuData.MenuItems.map((item, index) => {
                                                                            return (
                                                                                <div className="col-sm-4 col-md-3 col-6 subcategory-mgpd js-product ihop-listing-menucards-subcategory-section"
                                                                                    data-productid={item.MenuItemId} data-chainproductid={item.ChainProductId} data-menu-index={index + 1} data-subcategory={item.PageUrl.split('/')[3]}>
                                                                                    <MenuItemCard menuItemTitle={item.Name}
                                                                                        menuItemRestaurantId={MenuLandingPage.restaurantId}
                                                                                        menuItemProductId={item.MenuItemId}
                                                                                        menuItemPrice={item.Price}
                                                                                        menuItemImage={item.Image}
                                                                                        menuItemCalories={item.BaseCalories ? item.BaseCalories + (item.CalorieSeparator && item.MaxCalories ? " " + item.CalorieSeparator + " " : "") + item.MaxCalories : ""}
                                                                                        menuItemUrl={item.PageUrl}
                                                                                        menuItemOrderUrl={item.OrderUrl}
                                                                                        sendIsComboPage={this.getComboPage}
                                                                                        menuItemCalcPrice={item.CalcPrice}
                                                                                        calAbbr={this.menuListData.CalorieAbbr}
                                                                                        caloriesText={this.menuListData.CaloriesText}
                                                                                        quickAddText={this.menuListData.QuickAddText}
                                                                                        menuItemLabels={item.MenuItemLabels} />
                                                                                </div>
                                                                            )
                                                                        })
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </section>
                                                        </div>
                                                    );
                                                })
                                            }
                                        </div>
                                    </div>
                                    {!this.state.isComboPage && this.state.isMenuItemPage &&
                                        <section className="sub-category">
                                            <div className="container">
                                                <div className="row">
                                                    {this.state.menuItemCurrentData[0].MenuItems.map((item, index) => {
                                                        return (
                                                            <div className="col-sm-4 col-md-3 col-6 subcategory-mgpd js-product"
                                                                data-productid={item.MenuItemId} data-chainproductid={item.ChainProductId} data-menu-index={index + 1}>
                                                                <MenuItemCard menuItemTitle={item.Name}
                                                                    menuItemRestaurantId={MenuLandingPage.restaurantId}
                                                                    menuItemProductId={item.MenuItemId}
                                                                    menuItemPrice={item.Price}
                                                                    menuItemImage={item.Image}
                                                                    menuItemCalories={item.BaseCalories ? item.BaseCalories + (item.CalorieSeparator && item.MaxCalories ? " " + item.CalorieSeparator + " " : "") + item.MaxCalories : ""}
                                                                    menuItemUrl={item.PageUrl}
                                                                    menuItemOrderUrl={item.OrderUrl}
                                                                    sendIsComboPage={this.getComboPage}
                                                                    menuItemCalcPrice={item.CalcPrice}
                                                                    calAbbr={this.menuListData.CalorieAbbr}
                                                                    caloriesText={this.menuListData.CaloriesText}
                                                                    quickAddText={this.menuListData.QuickAddText}
                                                                    menuItemLabels={item.MenuItemLabels} />
                                                            </div>
                                                        )
                                                    })
                                                    }
                                                </div>
                                            </div>
                                        </section>

                                    }
                                    {(this.state.isComboPage && this.comboPageData != null) &&
                                        <ComboPage data={this.comboPageData} />
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        );
    }
}
